import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "workspace-subnav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "headline" }, "Workspace Settings", -1)
const _hoisted_3 = {
  class: "accordion accordion-flush",
  id: "accordion"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["data-bs-target", "aria-controls"]
const _hoisted_6 = ["id", "aria-labelledby"]
const _hoisted_7 = { class: "accordion-body" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, itemIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "accordion-item",
          key: item.label
        }, [
          _createElementVNode("h2", {
            class: "accordion-header",
            id: `heading${itemIndex}`
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["accordion-button", { collapsed: !item.active }]),
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#collapse${itemIndex}`,
              "aria-expanded": "false",
              "aria-controls": `collapse${itemIndex}`,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetActive && _ctx.resetActive(...args)))
            }, _toDisplayString(item.label), 11, _hoisted_5)
          ], 8, _hoisted_4),
          _createElementVNode("div", {
            id: `collapse${itemIndex}`,
            class: _normalizeClass(["accordion-collapse", { collapse: !item.active }]),
            "aria-labelledby": `heading${itemIndex}`,
            "data-bs-parent": "#accordion"
          }, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.links, (link) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: link.label
                }, [
                  (!link.externalLink)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: link.to,
                        class: "link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  (link.externalLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: link.externalLink,
                        class: "link",
                        target: "_blank"
                      }, _toDisplayString(link.label), 9, _hoisted_8))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ], 10, _hoisted_6)
        ]))
      }), 128))
    ])
  ]))
}